module.exports = global["surveylab_page_chars"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./chars.ts");